import React from 'react';

import { ArrowUpRight } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { RootState } from 'src/redux/store';
import { TrackGoogleAnalyticsEvent } from 'src/utils/google-analytics';

import { Container } from './styles';

export function ContactSales() {
  const { t: translate } = useTranslation();
  const { urlPrefix } = useSelector((state: RootState) => state.config);

  const location = useLocation();

  return (
    <Container>
      <h1>{translate('landingPageContactTitle')}</h1>

      <p>{translate('landingPageContactDescription')}</p>

      <Link
        to={`${urlPrefix}/contact-sales`}
        data-testid="contact-sales-button"
        onClick={() => {
          TrackGoogleAnalyticsEvent(
            'Falar com vendas',
            'Ir para tela Falar com Vendas',
            location.pathname,
          );
        }}
      >
        <ArrowUpRight />
        {translate('contactButton')}
      </Link>
    </Container>
  );
}
